/**
 * AG-Grid initialization utility
 * This module is lazy loaded to avoid including AG-Grid in the initial bundle
 */
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";

let agGridInitialized = false;

export function initializeAgGrid() {
  if (!agGridInitialized) {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
    agGridInitialized = true;
  }
}

